// @ts-nocheck
import type { Requests } from '../../../../base/realtime-session';
import type { MarketplaceHealthQueries } from '../../../../types/server/modules/marketplaceHealth/queries';

export type * from '../../../../types/server/modules/marketplaceHealth/queries';

export const createQueries = ( requests: Requests ): MarketplaceHealthQueries => ({
  SellerReputationReadmodelById: ( id, query, headers ) => { 
          return requests.get( `/seller-reputation-readmodel/${id}`, query, headers ); 
        },
  SellerReputationReadmodel: ( params?, headers? ) => {
        return requests.get( `/seller-reputation-readmodel/:id?`, params, headers );
      },
  ListingVisitsReadmodelById: ( id, query, headers ) => { 
          return requests.get( `/listing-visits-readmodel/${id}`, query, headers ); 
        },
  ListingVisitsReadmodel: ( params?, headers? ) => {
        return requests.get( `/listing-visits-readmodel/:id?`, params, headers );
      }
});
